import { create } from 'zustand'

/**
 * Toast store — lightweight, non-persisted notification queue.
 *
 * Use the `toast` helper anywhere (even outside React):
 *   toast.success('Registered for event')
 *   toast.error('Something went wrong')
 */
let counter = 0

export const useToastStore = create((set) => ({
  toasts: [],
  push: (t) => {
    const id = ++counter
    set((s) => ({ toasts: [...s.toasts, { id, type: 'info', duration: 3200, ...t }] }))
    return id
  },
  dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((x) => x.id !== id) })),
}))

export const toast = {
  success: (message) => useToastStore.getState().push({ type: 'success', message }),
  error:   (message) => useToastStore.getState().push({ type: 'error',   message }),
  info:    (message) => useToastStore.getState().push({ type: 'info',    message }),
}

export default useToastStore
